import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/produccion/cuentaContable';
import CuentaContable from './CuentaContable';


const ms2p = (state) => {
  return {
    ...state.cuenta_contable_prd,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(CuentaContable);
